// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u7lx0","badges":"styles_badges__1IRY1"};